/* eslint-disable */
/* global Provider */
import React, { Component } from 'react';
import BeginStep from './BeginStep.js';
import Header from './Header.js';
import Question from './Question.js';
import Step from './Step.js';
import ValidationMessage from './ValidationMessage';
import VerificationStep from './VerficationStep.js';
import QuartileStep from './QuartileStep';
import RiskProfileStep from './RiskProfileStep';
import GlideStep from './GlideStep.js';
import GrowthStep from './GrowthStep.js';
import ProgressBar from './ProgressBar';

class Wizard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            step: props.currentStep || 0,
            hasVerified: props.hasVerified || false
        };

        this.nextStepIndex = null;
        this.skipSteps = {};
        this.stepRefs = [];

        this.getStepRef = this.getStepRef.bind(this);
    }

    getStepRef(element) {
        this.stepRefs.push(element);
    }

    nextStep(count) {
        if (!this.canProceed()) return;
        let next = this.getActualStep(this.state.step + 1, true, count);
        this.setState({ step: next });
    }

    previousStep() {
        let prev = this.getActualStep(this.state.step - 1, false);
        this.setState({ step: prev });
    }

    getActualStep(guessStep, moveUp, count) {
        let output = guessStep;
        if (this.nextStepIndex) {
            output = this.nextStepIndex;
        } else {
            if (this.skipSteps[output.toString()]) {
                while (this.skipSteps[output.toString()]) {
                    output = output + (moveUp ? 1 : -1);
                }
            }
            if (output <= 0) output = 0;
            if (count && output > count) output = count;
        }
        this.nextStepIndex = null;
        return output;
    }

    gotoStep(stepNum) {
        let step = this.getActualStep(stepNum);
        this.setState({ step: step });
    }

    canProceed() {
        let step = this.state.step;

        if (step === 8 && !this.state.hasVerified) return false;

        let ref = this.stepRefs[step];
        if (ref) {
            if (ref.validate) {
                return ref.validate();
            }
            if (ref.props.validate) {
                return ref.props.validate();
            }
        }

        return true;
    }

    getClass(index) {
        return this.state.step > index ? 'before' : (this.state.step < index ? 'after' : 'active');
    }

    validateAnswers(questions, altAnswers) {
        let rObj = this.props.responses || {};
        let unansweredQuestions = questions.filter(qid => {
            let unanswered = rObj[qid] === undefined || rObj[qid] === null || rObj[qid] === '';
            if (unanswered) return unanswered;

            if (altAnswers && altAnswers.indexOf(qid) > -1) {
                if (rObj[qid].selected.text === 'Yes') { 
                    //console.log(JSON.stringify(rObj[qid]))
                    if (rObj[qid].twoDimensional) {
                        if (rObj[qid]['selectedLeftColumn'] == 'v. Other' || rObj[qid]['selectedRightColumn'] == 'v. Other') {
                            if ((rObj[qid]['selectedLeftColumn'] == 'v. Other' && !rObj[qid]['leftColumnNotes']) || (rObj[qid]['selectedRightColumn'] == 'v. Other' && !rObj[qid]['rightColumnNotes']) || !rObj[qid]['selectedLeftColumn'] || !rObj[qid]['selectedRightColumn']) {
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            if (rObj[qid]['selectedLeftColumn'] && rObj[qid]['selectedRightColumn']) {
                                return false;
                            } else {
                                return true;
                            }
                        }
                    } else {
                        if (rObj[qid].altSelected && rObj[qid].altSelected.text !== 'Other') {
                            return !rObj[qid].altSelected;
                        } else {
                            return !rObj[qid].altOther;
                        }
                    }
                }
            }

            return false;
        });

        if (unansweredQuestions.length > 0) {
            this.props.showModal('Error', <ValidationMessage items={unansweredQuestions} />);
            return false;
        } else {
            return true;
        }
    }

    validateEmail(emailAddress) {
        var sQtext = '[^\\x0d\\x22\\x5c\\x80-\\xff]';
        var sDtext = '[^\\x0d\\x5b-\\x5d\\x80-\\xff]';
        var sAtom = '[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+';
        var sQuotedPair = '\\x5c[\\x00-\\x7f]';
        var sDomainLiteral = '\\x5b(' + sDtext + '|' + sQuotedPair + ')*\\x5d';
        var sQuotedString = '\\x22(' + sQtext + '|' + sQuotedPair + ')*\\x22';
        var sDomain_ref = sAtom;
        var sSubDomain = '(' + sDomain_ref + '|' + sDomainLiteral + ')';
        var sWord = '(' + sAtom + '|' + sQuotedString + ')';
        var sDomain = sSubDomain + '(\\x2e' + sSubDomain + ')*';
        var sLocalPart = sWord + '(\\x2e' + sWord + ')*';
        var sAddrSpec = sLocalPart + '\\x40' + sDomain; // complete RFC822 email address spec
        var sValidEmail = '^' + sAddrSpec + '$'; // as whole string

        var reValidEmail = new RegExp(sValidEmail);

        return reValidEmail.test(emailAddress);
    }

render() {
    return [
        <Header key="header">
            <div className="tabs">
            </div>
        </Header>,
        <section className="wizard" key="wizard">
            <div className="container">
                <div className={"step-controller clearfix"}>
                    {this.state.step > 0 ?
                        <button className="btn btn-secondary float-left btn-sm" onClick={(event) => {
                            this.previousStep();
                            event.target.blur();
                        }}>Back</button>
                        : null}

                    {this.state.step < this.stepRefs.length - 1 && this.state.step !== 0 ?
                        <div className="float-right">
                            <button className="btn btn-success btn-sm" onClick={(event) => {
                                this.nextStep();
                                event.target.blur();
                            }}>Next</button>
                        </div>
                        : null}
                </div>
                <div className="steps">
                    <BeginStep ref={this.getStepRef} className={this.getClass(0)} onBeginClick={() => {
                        this.nextStep();
                    }} validate={() => {
                        return true;
                    }} />
                    <Step ref={this.getStepRef} className={this.getClass(1)} validate={() => {
                        return this.validateAnswers(['name', '1']);
                    }}>
                        <h1>Questionnaire:<ProgressBar count={6} step={1} /></h1>
                        <div>
                            <div className="survey-question">
                                <span>Enter the name of the plan:</span>
                                <div className="row">
                                    <div className="col-sm field">
                                        <input type="test" className="form-control" placeholder="Plan Name" onBlur={(event) => {
                                            Provider.setResponse('name', event.target.value);
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <Question id="1" onAfterSelection={(event, option, index) => {
                                if (index === 1) {
                                    this.skipSteps[2] = true;
                                    this.skipSteps[3] = true;
                                } else {
                                    this.skipSteps[2] = false;
                                    this.skipSteps[3] = false;
                                }
                            }} />
                        </div>
                    </Step>
                    <Step ref={this.getStepRef} className={this.getClass(2)} validate={() => {
                        return this.validateAnswers(['2', '3', '4'], ['2', '3']);
                    }}>
                        <h1>Questionnaire:<ProgressBar count={6} step={2} /></h1>
                        <div>
                            <Question id="2" />
                            <Question id="3" />
                            <Question id="4" />
                        </div>
                    </Step>
                    <Step ref={this.getStepRef} className={this.getClass(3)} validate={() => {
                        return this.validateAnswers(['5', '6', '7'], ['5']);
                    }}>
                        <h1>Questionnaire:<ProgressBar count={6} step={3} /></h1>
                        <div>
                            <Question id="5" />
                            <Question id="6" />
                            <Question id="7" />
                        </div>
                    </Step>
                    <Step ref={this.getStepRef} className={this.getClass(4)} validate={() => {
                        return this.validateAnswers(['8', '9', '10', '11']);
                    }}>
                        <h1>Questionnaire:<ProgressBar count={6} step={4} /></h1>
                        <div>
                            <Question id="8" />
                            <Question id="9" />
                            <Question id="10" />
                            <Question id="11" />
                        </div>
                    </Step>
                    <Step ref={this.getStepRef} className={this.getClass(5)} validate={() => {
                        return this.validateAnswers(['12', '13', '14', '15']);
                    }}>
                        <h1>Questionnaire:<ProgressBar count={6} step={5} /></h1>
                        <div>
                            <Question id="12" />
                            <Question id="13" />
                            <Question id="14" />
                            <Question id="15" />
                        </div>
                    </Step>
                    <Step ref={this.getStepRef} className={this.getClass(6)} validate={() => {
                        return this.validateAnswers(['16', '17', '18', '19']);
                    }}>
                        <h1>Questionnaire:<ProgressBar count={6} step={6} /></h1>
                        <div>
                            <Question id="16" />
                            <Question id="17" />
                            <Question id="18" />
                            <Question id="19" />
                        </div>
                    </Step>
                    <VerificationStep ref={this.getStepRef} className={this.getClass(7)} active={this.state.step === 7}
                        onVerificationCancelled={() => {
                            this.previousStep();
                        }}
                        onVerified={(verified) => {
                            this.setState({ hasVerified: verified }, () => {
                                this.skipSteps[7] = verified;
                                this.nextStep();
                            });
                        }}
                    />
                    <RiskProfileStep ref={this.getStepRef} className={this.getClass(8)} {...this.props} />
                    <QuartileStep ref={this.getStepRef} className={this.getClass(9)} {...this.props} />
                    <GlideStep ref={this.getStepRef} className={this.getClass(10)} {...this.props} />
                    <GrowthStep ref={this.getStepRef} className={this.getClass(11)} {...this.props} />
                </div>
                <div className={"step-controller clearfix"}>
                    {this.state.step > 0 ?
                        <button className="btn btn-secondary float-left btn-sm" onClick={(event) => {
                            this.previousStep();
                            event.target.blur();
                        }}>Back</button>
                        : null}

                    {this.state.step < this.stepRefs.length - 1 && this.state.step !== 0 ?
                        <div className="float-right">
                            <button className="btn btn-success btn-sm" onClick={(event) => {
                                this.nextStep();
                                event.target.blur();
                            }}>Next</button>
                        </div>
                        : null}
                </div>
            </div>
        </section>
    ];
}
}

export default Wizard;